import { USER_ROLES } from '@/constants'
import helpers from '@/utils/helpers.ts'
import { useOrganization } from './organization'

export function useOrganizationRoles() {
  const { currentOrg } = useOrganization()

  /**
   *  Owner has the only Role that has the role: "MANAGE_COMPANY"
   * */
  const isOwner = computed(() =>
    currentOrg.value?.roles.includes(USER_ROLES.USER_ROLE_MANAGE_COMPANY),
  )

  /**
   *  Admin has almost the same roles as owner but DO NOT HAVE the role: "MANAGE_COMPANY"
   * */
  const isAdmin = computed(
    () =>
      !!currentOrg.value &&
      currentOrg.value.roles.length > 1 &&
      !currentOrg.value.roles.includes(USER_ROLES.USER_ROLE_MANAGE_COMPANY),
  )

  /**
   *  Member has only 1 Role: "VIEW_COMPANY"
   * */
  const isMember = computed(
    () =>
      !!currentOrg.value &&
      currentOrg.value.roles.length === 1 &&
      currentOrg.value.roles.includes(USER_ROLES.USER_ROLE_VIEW_COMPANY),
  )

  const isOwnerOrAdmin = computed(() => isOwner.value || isAdmin.value)

  const canManageDeepBox = computed(() =>
    helpers.hasUserRole(USER_ROLES.USER_ROLE_MANAGE_BOXES, currentOrg.value),
  )

  return {
    currentOrg,
    isOwner,
    isAdmin,
    isMember,
    isOwnerOrAdmin,
    canManageDeepBox,
  }
}
